<template>
    <div>
        <w-profile v-if="user.username && user.attributes" class="no-header profile" :auth="Auth" :logger="null" :user="user" @updated="updated" :show-preview="false" :changed.sync="changed"></w-profile>
    </div>
</template>

<script>
import Auth from '@aws-amplify/auth'
import { CONFIG } from '../aws'
import Cookies from 'js-cookie'
import { sendToSlack } from '../mixins'

export default {
    name: 'Profile',
    data () {
        return {
            Auth,
            changed: true
        }
    },
    computed: {
        user () {
            return this.$store.getters['auth/user']
        },
        userId () {
            return this.$store.getters['auth/userId']
        }
    },
    methods: {
        updated () {
            const cookies = Cookies.get()
            const userDataKey = Object.keys(cookies).find(item => item.endsWith('userData'))
            Cookies.remove(userDataKey, { path: CONFIG.cookieStorage.path, domain: CONFIG.cookieStorage.domain })
            this.$store.dispatch('auth/fetchUser').then(() => {
                this.changed = false
            })
        }
    },
    mounted () {
        this.$stopSpinner()
    },
    created () {
        Auth.currentUserInfo().catch(err => sendToSlack(err, {}, Cookies.get()))
    }
}
</script>

<style scoped>
    .profile {
        margin-left: 17px;
        margin-right: 17px;
    }
</style>
